import React from 'react'
import { Icon } from './Shield.elements'

type Props = {
  className?: string
}

export const ShieldIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 16 17"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <g clipPath="url(#clip-shield)" stroke="currentColor" strokeWidth="2">
      <path d="M2.929 4.314l-.596.263V6.82a8.346 8.346 0 003.817 7.01l1.307.844.543.35.542-.35 1.308-.845a8.346 8.346 0 003.816-7.01v-2.24l-.596-.264-4.666-2.062L8 2.073l-.404.179-4.667 2.062z" />
      <path d="M6 8.5l1.333 1.333L10 7.166" />
    </g>
    <defs>
      <clipPath id="clip-shield">
        <rect width="16" height="16" fill="#fff" transform="translate(0 .5)" />
      </clipPath>
    </defs>
  </Icon>
)
